import { companyInfo } from '@/mocks/company';

export default function WhatsAppFloat() {
  const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco pelo WhatsApp"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-50 group"
    >
      {/* Pulso de atenção */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 pointer-events-none" />

      {/* Conteúdo do botão */}
      <span className="relative flex items-center bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full shadow-lg shadow-[#25D366]/30 transition-all duration-300 hover:scale-[1.03] cursor-pointer overflow-hidden">
        {/* Label desktop: expande no hover */}
        <span className="hidden md:flex items-center whitespace-nowrap text-sm font-bold tracking-wide max-w-0 group-hover:max-w-[180px] group-hover:pl-5 overflow-hidden transition-all duration-300">
          Fale pelo WhatsApp
        </span>

        {/* Label mobile: sempre visível */}
        <span className="md:hidden flex items-center whitespace-nowrap text-sm font-bold tracking-wide pl-5">
          WhatsApp
        </span>

        <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center flex-shrink-0">
          <i className="ri-whatsapp-line text-2xl md:text-[26px]"></i>
        </span>
      </span>
    </a>
  );
}